// extracted by mini-css-extract-plugin
export default {"tabs":"DevelopersTabs_tabs__VKFHf","main":"DevelopersTabs_main__u10P2"};